module.exports = __webpack_public_path__ + "static/img/wavm8s-016-klahrk.8c737a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-016-klahrk.png
// module id = /xFA
// module chunks = 0